import { faCircleCheck, faUserGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import prize from "../../../assets/icons/gift_box.png";
import partyFlag from "../../../assets/partyFlag.png";
import tafseer_class_img from "../../../assets/tafseer/quran_minar.png";
import NextBatchRegCard from "./../../CourseRegistration/NextBatchRegCard";
import RegisterNow from "./../../utils/RegisterNow";
import TafseerCourseTeacher from "./Registration/TafseerCourseTeacher";
import TafseerCourseFee from "./TafseerCourseFee";
import TafseerSchedule from "./TafseerSchedule";

const tafseer_1_syllabus_usul = [
  "আল কুরআন",
  "কুরআন নাযিলের ইতিহাস",
  "কুরআন নাযিল হওয়ার নিয়ম",
  "শানে নুযুল জানার উপকারিতা",
  "মাক্কী ও মাদানী সূরা",
  "মাক্কী ও মাদানীর সূরার মৌলিক বৈশিষ্ট",
  "কুরআন বিচ্ছিন্নভাবে / অল্প অল্প করে নাযিল হওয়ার হেকমত",
  "পবিত্র কুরআনের বিন্যাস ও ধারাবাহিকতা",
  "কুরআন সংকলনের পর্যায়সমুহ",
  "তাফসীরের সংজ্ঞা",
  "মুফাসসিরের আদব",
  "ইলমে তাফসীরের সূচনা ও তার পর্যায় সমূহ",
  "তাফসীরের প্রকারভেদ",
  "জ্ঞান-বিজ্ঞানের বিষয়ে গুরুত্বারোপকারী তাফসীর সমূহ",
  "ইশার-ইঙ্গিতের প্রতি গুরুত্বারোপকারী তাফসীর সমূহ",
  "সাহিত্য ও সামাজিকতার প্রতি গুরুত্বারোপকারী তাফসীর সমূহ",
  "ফিকহী বিষয়ের প্রতি গুরুত্বারোপকারী তাফসীর সমূহ",
  "বিদআতীদের তাফসীর সমূহ",
];

const tafseer_1_syllabus_sura = [
  "আউযুবিল্লাহ এর তাফসীর",
  "বিসমিল্লাহ এর তাফসীর",
  "সূরা ফাতিহার তাফসীর",
  "সূরা নাস-এর তাফসীর",
  "সূরা ফালাক -এর তাফসীর",
  "সূরা ইখলাস -এর তাফসীর",
  "সূরা লাহাব -এর তাফসীর",
  "সূরা নসর -এর তাফসীর",
  "সূরা কাফেরুন -এর তাফসীর",
  "সূরা কাওসার -এর তাফসীর",
  "সূরা আল মাউন -এর তাফসীর",
  "সূরা কুরাইশ -এর তাফসীর",
  "সূরা আল ফীল -এর তাফসীর",
  "সূরা হুমাযাহ -এর তাফসীর",
  "সূরা আসর-এর তাফসীর",
  "সূরা আত তাকাসুর -এর তাফসীর",
  "সূরা আল কারেয়া -এর তাফসীর",
  "সূরা আল আদিয়াত-এর তাফসীর",
  "সূরা যিলযাল -এর তাফসীর",
  "সূরা বাইয়েনাহ -এর তাফসীর",
  "সূরা আল কদর -এর তাফসীর",
  "সূরা আলাক -এর তাফসীর",
];

const TafseerInfo = () => {
  return (
    <div className="container mx-auto px-5 my-10">
      {/* Welcome  */}

      <section>
        <div className="rounded bg-gradient-to-tl from-sky-200 flex justify-between header-card">
          <div className="p-5">
            <p className="text-3xl">সংক্ষিপ্ত তাফসীর কোর্সে</p>
            <p className="text-4xl">স্বাগতম!</p>
          </div>
          <div className="p-5 hidden md:inline">
            <div className="flex justify-between">
              <div className="text-right font-serif align-middle mr-10">
                <p className="text-4xl ">دورة التفسير المختصر</p>
                <p className="text-2xl">للقرآن الكريم</p>
              </div>
              <div>
                <img src={partyFlag} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Course Descripttion  */}

      <section className="my-10">
        <p className="text-xl">কোর্স পরিচিতিঃ</p>
        <p>
          পবিত্র কুরআন কেবল তিলাওয়াতের জন্য নয়, বরং এটি মানবজাতির জন্য এক
          পূর্ণাঙ্গ জীবনবিধান। আল্লাহ তা’আলা এই কিতাব অবতীর্ণ করেছেন যাতে আমরা
          এর আয়াতগুলো নিয়ে গভীরভাবে চিন্তা-ভাবনা করি এবং এর নিগূঢ় রহস্য উপলব্ধি
          করতে পারি। আল্লাহ বলেন - "তারা কি কুরআন নিয়ে গভীরভাবে চিন্তা করে না?
          নাকি তাদের অন্তরে তালা দেয়া আছে?" (সূরা মুহাম্মদ: ২৪)"
        </p>
        <p>
          এই কোর্সে আমরা কুরআনের সূরা ফাতেহাসহ ২০টি ছোট সূরা সংক্ষিপ্তভাবে
          তাফসীর পড়ব, অর্থাৎ আয়াতগুলোর অর্থ ও মর্ম বুঝতে চেষ্টা করব, তবে খুব
          বেশি বিস্তারিত তাফসীর করব না। ইনশা আল্লাহ।
        </p>
        <p></p>
      </section>

      {/* in short  */}
      <section className="mt-20 mb-10">
        <div className="flex flex-col md:flex-row justify-around items-center">
          <div className="mb-8 md:mb-0">
            <img className="rounded-lg" src={tafseer_class_img} />
          </div>
          <div>
            <p className="text-xl my-4">এক নজরে</p>

            <p>
              <FontAwesomeIcon
                className="text-green-600 pr-2"
                icon={faCircleCheck}
              />
              ৩ মাসের কোর্স
            </p>
            <p>
              <FontAwesomeIcon
                className="text-green-600 pr-2"
                icon={faCircleCheck}
              />
              কোর্স শেষে সার্টিফিকেট
            </p>
            <p>
              <FontAwesomeIcon
                className="text-green-600 pr-2"
                icon={faUserGroup}
              />
              পুরুষ - মহিলা আলাদা গ্রুপ
            </p>

            <p>
              <FontAwesomeIcon
                className="text-green-600 pr-2"
                icon="fa-solid fa-clock"
              />
              সপ্তাহে ৩ দিন রেকর্ডেড ক্লাস ও ক্লাস টেস্ট
            </p>
          </div>
        </div>
      </section>

      {/* register now  */}
      <section>
        <RegisterNow course="tafseer"></RegisterNow>
      </section>

      {/* Gift */}
      <section className="my-20 bg-yellow-200 rounded p-5 gift-box">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center ">
          <div className="order-2 mx-auto">
            <p className="text-xl my-4">সেরা ৩ জনকে পুরষ্কৃত করা হবে</p>
            <p>এই কোর্সে ৩টি ১০০ মার্কের পরীক্ষা হবে।</p>
            <p>
              পরীক্ষায় সর্বোচ্চ রেজাল্টকারীদের মধ্যে সেরা ৩ জনকে পুরষ্কৃত করা
              হবে।
            </p>
          </div>
          <div className="order-1 md:order-3">
            <img className="rounded-lg block mx-auto my-10 " src={prize} />
          </div>
        </div>
      </section>

      {/* Syllabus  */}
      <section>
        <div className="mt-10">
          <p className="text-xl my-8">কোর্সের বিষয়বস্তুঃ উসুলে তাফসীর</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {tafseer_1_syllabus_usul.map((item, i) => (
              <p key={i}>
                <FontAwesomeIcon
                  className="text-green-700 pr-2"
                  icon={faCircleCheck}
                />
                {item}
              </p>
            ))}
          </div>
        </div>
        <div className="mt-10">
          <p className="text-xl my-8">কোর্সের বিষয়বস্তুঃ সংক্ষিপ্ত তাফসীর</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {tafseer_1_syllabus_sura.map((item, i) => (
              <p key={i}>
                <FontAwesomeIcon
                  className="text-purple-700 pr-2"
                  icon={faCircleCheck}
                />
                {item}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* schedule  */}

      <section>
        <TafseerSchedule />
      </section>

      {/* Course Fee  */}
      <TafseerCourseFee />

      {/* <CardTafseerNextBatch /> */}
      <NextBatchRegCard course="tafseer" />

      <TafseerCourseTeacher />
    </div>
  );
};

export default TafseerInfo;
